import type { ConsentPreferences } from '../CookieConsent.types';

declare global {
  function gtag(...args: unknown[]): void;
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function updateGTMConsent(preferences: ConsentPreferences): void {
  if (typeof gtag !== 'function') return;

  gtag('consent', 'update', {
    analytics_storage: preferences.analytics ? 'granted' : 'denied',
    ad_storage: preferences.marketing ? 'granted' : 'denied',
    ad_user_data: preferences.marketing ? 'granted' : 'denied',
    ad_personalization: preferences.marketing ? 'granted' : 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    personalization_storage: preferences.analytics ? 'granted' : 'denied',
  });
}

export function pushConsentEvent(action: string): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'cookie_consent_update',
    consent_action: action,
  });
}
